import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from "@angular/router";
import {Location} from '@angular/common';

import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {UserRole} from "../type/user-role";

@Component({
    selector: 'app-user-role-edit',
    templateUrl: './user-role-edit.component.html',
})
export class UserRoleEditComponent implements OnInit {

    node = 'user-role';
    userRole: UserRole = UserRole;

    constructor(private dataService: DataService,
                private apiService: ApiService,
                private route: ActivatedRoute,
                private location: Location) {
    }

    ngOnInit(): void {
        this.dataService.refresh();
        this.route.params
            .subscribe(
                (params: Params) => {
                    this.apiService.getUsingId(this.node, +params['id'])
                        .subscribe((response) => {
                            this.dataService.updateActiveRequestNo(-1);
                            this.userRole = response.json().data[0];
                        });
                }
            );
    }

    onFormSubmit() {
        this.apiService.update(this.node, [this.userRole.user_role_id], this.userRole)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: Unable to submit form');
                    } else {
                        alert('Success: User Role updated successfully');
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }
}



// WEBPACK FOOTER //
// ./src/app/user-roles/user-role-edit.component.ts